/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MstTransportRelation
 */
export interface MstTransportRelation {
    /**
     * 
     * @type {number}
     * @memberof MstTransportRelation
     */
    companyId: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstTransportRelation
     */
    centerId: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportRelation
     */
    orgCenterId: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstTransportRelation
     */
    customerCompanyId: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstTransportRelation
     */
    customerCenterId: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportRelation
     */
    orgCustomerId: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportRelation
     */
    orgCustomerCenterId: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportRelation
     */
    customerName: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportRelation
     */
    customerCenterName: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportRelation
     */
    transportOrgCenterId: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstTransportRelation
     */
    leadtime: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstTransportRelation
     */
    maxTrafficVolume: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportRelation
     */
    remarks: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstTransportRelation
     */
    insertDatetime: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof MstTransportRelation
     */
    updateDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportRelation
     */
    insertUser: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportRelation
     */
    updateUser: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstTransportRelation
     */
    deleteDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportRelation
     */
    deleteUser: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstTransportRelation
     */
    deleteFlg: boolean | null;
}

/**
 * Check if a given object implements the MstTransportRelation interface.
 */
export function instanceOfMstTransportRelation(value: object): value is MstTransportRelation {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('centerId' in value) || value['centerId'] === undefined) return false;
    if (!('orgCenterId' in value) || value['orgCenterId'] === undefined) return false;
    if (!('customerCompanyId' in value) || value['customerCompanyId'] === undefined) return false;
    if (!('customerCenterId' in value) || value['customerCenterId'] === undefined) return false;
    if (!('orgCustomerId' in value) || value['orgCustomerId'] === undefined) return false;
    if (!('orgCustomerCenterId' in value) || value['orgCustomerCenterId'] === undefined) return false;
    if (!('customerName' in value) || value['customerName'] === undefined) return false;
    if (!('customerCenterName' in value) || value['customerCenterName'] === undefined) return false;
    if (!('transportOrgCenterId' in value) || value['transportOrgCenterId'] === undefined) return false;
    if (!('leadtime' in value) || value['leadtime'] === undefined) return false;
    if (!('maxTrafficVolume' in value) || value['maxTrafficVolume'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    if (!('insertDatetime' in value) || value['insertDatetime'] === undefined) return false;
    if (!('updateDatetime' in value) || value['updateDatetime'] === undefined) return false;
    if (!('insertUser' in value) || value['insertUser'] === undefined) return false;
    if (!('updateUser' in value) || value['updateUser'] === undefined) return false;
    if (!('deleteDatetime' in value) || value['deleteDatetime'] === undefined) return false;
    if (!('deleteUser' in value) || value['deleteUser'] === undefined) return false;
    if (!('deleteFlg' in value) || value['deleteFlg'] === undefined) return false;
    return true;
}

export function MstTransportRelationFromJSON(json: any): MstTransportRelation {
    return MstTransportRelationFromJSONTyped(json, false);
}

export function MstTransportRelationFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstTransportRelation {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'centerId': json['center_id'],
        'orgCenterId': json['org_center_id'],
        'customerCompanyId': json['customer_company_id'],
        'customerCenterId': json['customer_center_id'],
        'orgCustomerId': json['org_customer_id'],
        'orgCustomerCenterId': json['org_customer_center_id'],
        'customerName': json['customer_name'],
        'customerCenterName': json['customer_center_name'],
        'transportOrgCenterId': json['transport_org_center_id'],
        'leadtime': json['leadtime'],
        'maxTrafficVolume': json['max_traffic_volume'],
        'remarks': json['remarks'],
        'insertDatetime': (json['insert_datetime'] == null ? null : new Date(json['insert_datetime'])),
        'updateDatetime': (json['update_datetime'] == null ? null : new Date(json['update_datetime'])),
        'insertUser': json['insert_user'],
        'updateUser': json['update_user'],
        'deleteDatetime': (json['delete_datetime'] == null ? null : new Date(json['delete_datetime'])),
        'deleteUser': json['delete_user'],
        'deleteFlg': json['delete_flg'],
    };
}

export function MstTransportRelationToJSON(json: any): MstTransportRelation {
    return MstTransportRelationToJSONTyped(json, false);
}

export function MstTransportRelationToJSONTyped(value?: MstTransportRelation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'center_id': value['centerId'],
        'org_center_id': value['orgCenterId'],
        'customer_company_id': value['customerCompanyId'],
        'customer_center_id': value['customerCenterId'],
        'org_customer_id': value['orgCustomerId'],
        'org_customer_center_id': value['orgCustomerCenterId'],
        'customer_name': value['customerName'],
        'customer_center_name': value['customerCenterName'],
        'transport_org_center_id': value['transportOrgCenterId'],
        'leadtime': value['leadtime'],
        'max_traffic_volume': value['maxTrafficVolume'],
        'remarks': value['remarks'],
        'insert_datetime': value['insertDatetime'] == null ? value['insertDatetime'] : value['insertDatetime'].toISOString(),
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
        'insert_user': value['insertUser'],
        'update_user': value['updateUser'],
        'delete_datetime': value['deleteDatetime'] == null ? value['deleteDatetime'] : value['deleteDatetime'].toISOString(),
        'delete_user': value['deleteUser'],
        'delete_flg': value['deleteFlg'],
    };
}

